import { cookieStorage } from '../services';

const getIsAdmin = async () => {
  const { data } = await cookieStorage.get('is-admin-user');
  return !!data;
};

export default getIsAdmin;
